import type React from 'react';

import { BottomSheet } from '@xing-com/bottom-sheet';
import type { BottomSheetProps } from '@xing-com/bottom-sheet';

import { BottomSheetContentContainer } from './styles';

export type FlagBottomSheetProps = {
  body?: string[];
  showBottomSheet?: boolean;
  setShowBottomSheet?: (setActive: boolean) => void;
  premiumTheme: boolean;
};

export const FlagBottomSheet: React.FC<
  FlagBottomSheetProps & BottomSheetProps
> = ({ showBottomSheet, setShowBottomSheet, premiumTheme, children }) => {
  return (
    <BottomSheet
      show={showBottomSheet}
      onOutsideClick={() => setShowBottomSheet && setShowBottomSheet(false)}
      data-testid="user-flag-content"
    >
      <BottomSheetContentContainer $premiumTheme={premiumTheme}>
        {children}
      </BottomSheetContentContainer>
    </BottomSheet>
  );
};
